import { Link } from "react-router-dom";
import { MapPin, CalendarClock, ChevronRight } from "lucide-react";
import { CategoryBadge, StatusBadge } from "@/components/Badges";
import { fmtDateTime } from "@/lib/api";

export const TaskCard = ({ t, i = 0 }) => (
  <Link to={`/app/tasks/${t.id}`} data-testid={`task-item-card-${t.id}`} style={{ animationDelay: `${i * 60}ms` }}
    className="fade-up block bg-white rounded-xl border border-slate-200 p-4 hover:border-sky-400 hover:shadow-sm transition-[border-color,box-shadow]">
    <div className="flex items-center justify-between gap-2">
      <CategoryBadge category={t.category} />
      <StatusBadge status={t.status} />
    </div>
    <div className="font-heading font-bold text-lg text-slate-900 mt-2 leading-snug">{t.task_title}</div>
    <div className="text-sm text-slate-600 mt-1 flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-slate-400" />{t.client?.hospital_name}</div>
    <div className="flex items-center justify-between mt-3">
      <div className="text-xs text-slate-500 flex items-center gap-1.5"><CalendarClock className="h-3.5 w-3.5" />Due {fmtDateTime(t.due_date)}</div>
      <ChevronRight className="h-4 w-4 text-slate-400" />
    </div>
  </Link>
);
